var Clear = "Clear";
var EN_TRANSLATION = {
  "Order History": "Order History",
  "Log In": "Log In",
  "Sign Up": "Sign Up",
  "UI Account": "UI Account",
  "UniFi Site Manager": "UniFi Site Manager",
  "Manage Account": "Manage Account",
  "Sign Out": "Sign Out",
  Clear: Clear,
  "Show Me": "Show Me",
  "Terms and Conditions": "Terms and Conditions",
  "Privacy policy": "Privacy policy"
};
export { Clear, EN_TRANSLATION as default };
//# sourceMappingURL=en.json.mjs.map
